import { Link } from "react-router-dom";
import * as Icons from "lucide-react";
import { useApp } from "../context/AppContext";
import { tr, pick } from "../i18n/translations";

const CAT_IMAGES = {
  "orthophonie": "https://images.unsplash.com/photo-1758273241078-8eec353836be?w=800&q=80",
  "langage-ecrit": "https://images.unsplash.com/photo-1532153975070-2e9ab71f1b14?w=800&q=80",
  "logico-math": "https://images.unsplash.com/photo-1635070041078-e363dbe005cb?w=800&q=80",
  "memoire-attention": "https://images.unsplash.com/photo-1493612276216-ee3925520721?w=800&q=80",
  "praxies-motricite": "https://images.unsplash.com/photo-1535572290543-960a8046f5af?w=800&q=80",
  "communication-alternative": "https://images.unsplash.com/photo-1576091160550-2173dba999ef?w=800&q=80",
  "cognition-raisonnement": "https://images.unsplash.com/photo-1611532736597-de2d4265fba3?w=800&q=80",
  "ecole-maternelle": "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&q=80",
  "livres-pedagogiques": "https://images.unsplash.com/photo-1532012197267-da84d127e765?w=800&q=80",
  "outils-numeriques": "https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=800&q=80",
  "mobilier-ergonomique": "https://images.unsplash.com/photo-1493934558415-9d19f0b2b4d2?w=800&q=80",
  "cadeaux-recompenses": "https://images.unsplash.com/photo-1513885535751-8b9238bd345a?w=800&q=80",
  "formation-continue": "https://images.unsplash.com/photo-1481627834876-b7833e8f5570?w=800&q=80",
  "amenagement-cabinet": "https://images.unsplash.com/photo-1564540583246-934409427776?w=800&q=80",
};

const SPANS = [
  "md:col-span-2 md:row-span-2", "md:col-span-1", "md:col-span-1",
  "md:col-span-1", "md:col-span-2", "md:col-span-1",
  "md:col-span-1", "md:col-span-1", "md:col-span-2",
  "md:col-span-2", "md:col-span-1", "md:col-span-1",
  "md:col-span-1", "md:col-span-1",
];

export default function CategoryBento({ categories }) {
  const { lang } = useApp();
  return (
    <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16" data-testid="category-bento">
      <div className="flex items-end justify-between mb-10 gap-4 flex-wrap">
        <div className="max-w-2xl">
          <p className="text-xs uppercase tracking-[0.25em] text-ink/60 mb-3">{(categories || []).length} univers</p>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-light tracking-tight">
            {tr(lang, "cats_title")}
          </h2>
          <p className="mt-3 text-ink-soft">{tr(lang, "cats_sub")}</p>
        </div>
        <Link to="/catalogue" className="btn-ghost" data-testid="cats-see-all">Tout voir →</Link>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5 auto-rows-[200px]">
        {(categories || []).map((c, i) => {
          const Icon = Icons[c.icon] || Icons.Tag;
          const img = c.image || CAT_IMAGES[c.slug] || CAT_IMAGES["orthophonie"];
          return (
            <Link
              key={c.slug}
              to={`/categorie/${c.slug}`}
              data-testid={`bento-cat-${c.slug}`}
              className={`relative rounded-3xl overflow-hidden group bg-cover bg-center ${SPANS[i] || ""}`}
              style={{ backgroundImage: `url(${img})` }}
            >
              <div className="absolute inset-0 bg-gradient-to-t from-ink/80 via-ink/20 to-transparent group-hover:from-ink/90 transition" />
              <div className="absolute inset-0 p-5 flex flex-col justify-between text-ivory">
                <div className="w-10 h-10 rounded-full bg-ivory/15 backdrop-blur-md border border-ivory/20 flex items-center justify-center">
                  <Icon size={18} />
                </div>
                <div>
                  <p className="font-display text-xl md:text-2xl leading-tight">{pick(c.name, lang)}</p>
                  <p className="text-xs text-ivory/70 mt-1">{pick(c.description, lang)}</p>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
